import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';
import { SzIconName } from './sz-icon-name.type';

@Component({
  selector: 'sz-icon',
  templateUrl: './sz-icon.component.html',
  styleUrls: ['./sz-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzIconComponent {
  readonly name: InputSignal<SzIconName> = input.required<SzIconName>();
  readonly size: InputSignal<number> = input<number>(20);

  readonly href: Signal<string> = computed((): string => `assets/icons/sprite.svg#${this.name()}`);
  readonly pixels: Signal<string> = computed((): string => `${this.size()}px`);
}
